import { render, staticRenderFns } from "./TableElem.vue?vue&type=template&id=3ee6860a&scoped=true&"
import script from "./TableElem.vue?vue&type=script&lang=js&"
export * from "./TableElem.vue?vue&type=script&lang=js&"
import style0 from "./TableElem.vue?vue&type=style&index=0&id=3ee6860a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee6860a",
  null
  
)

export default component.exports